import type { ResolveOrganizationBreadcrumbLabelParams } from '../types';

const resolveOrganizationBreadcrumbLabel = ({
    organizationId,
    organizations,
    isLoadingOrganizations,
}: ResolveOrganizationBreadcrumbLabelParams): string => {
    if (!organizationId) {
        return '';
    }

    const organization = organizations.find(candidate => candidate.id === organizationId);
    if (organization) {
        return organization.name;
    }

    if (isLoadingOrganizations) {
        return '...';
    }

    return organizationId;
};

export default resolveOrganizationBreadcrumbLabel;
